import { ProductEvents } from 'types/analytics/product/product.enum';
import { HOTSITE_INDEXES } from '@helpers/algolia/constants';
import useAnalyticsListId from '@helpers/analytics/useAnalyticsListId';
import { useProductListing } from 'contexts/productListingContext';
import trackEvent from 'event-tracks';
import { parseCookies } from 'nookies';

interface TListFilterProps {
  typeName?: string;
  elementName?: string;
  elementPosition?: number | string;
  algIndex?: string;
  typeFixedPosition?: number;
  isThreeSteps?: boolean;
  isWishlist?: boolean;
}

let facetsElements;
let togglesCountToAdd;
let hotsiteAlgoliaIndex = HOTSITE_INDEXES[0].value;

export function getValuesRuleContextFacets(objFacetsElement: Array<any>): void {
  facetsElements = objFacetsElement;
}
export function getToggleslenght(togglesLenght: number): void {
  togglesCountToAdd = togglesLenght;
}
export function getHotsiteAlgoliaIndex(algoliaIndexForHotsite: string): void {
  hotsiteAlgoliaIndex = algoliaIndexForHotsite;
}

export const useListFilter = () => {
  const listId = useAnalyticsListId();
  const { currentIndex } = useProductListing() || {};

  const parseFacetName = (facetName: string) => {
    if (!facetName || Array.isArray(facetName)) {
      return '';
    }
    return facetName.replace('product_hub.attributes.', '').replace('preco_promocional', 'Preço');
  };

  const isHotsite = () => document.location.href.indexOf('hotsite') > -1;

  const getListId = () => {
    const url = document.location.pathname.split('/').pop();
    if (document.location.href.indexOf('.html') > -1) {
      return 'PLA';
    }
    return url;
  };

  const trackListFilter = ({
    typeName,
    elementName,
    elementPosition,
    algIndex,
    typeFixedPosition,
    isThreeSteps,
    isWishlist,
  }: TListFilterProps) => {
    const getTypePosition = () => {
      const isFacetElement = Array.isArray(facetsElements)
        ? facetsElements.findIndex(item => item.props.title === parseFacetName(typeName)) + 1
        : 0;

      if (isFacetElement && isHotsite()) {
        return isFacetElement + togglesCountToAdd;
      }
      if (isThreeSteps) {
        return typeFixedPosition;
      }
      return isFacetElement || typeFixedPosition;
    };

    const getPayload = () => {
      if (isWishlist) {
        return {
          event_date: new Date().toISOString(),
          list_id: listId,
          product_alg_query_id: parseCookies().queryID,
          filter_type: `1| ${typeName}`,
          filter_element: `${elementPosition}| ${elementName}`,
          product_alg_index: null,
          filter_action: isThreeSteps ? '3 passos' : 'Normal',
        };
      }

      return {
        event_date: new Date().toISOString(),
        list_id: listId,
        product_alg_query_id: parseCookies().queryID,
        filter_type: `${getTypePosition()}| ${parseFacetName(typeName)}`,
        filter_element: `${elementPosition}| ${elementName}`,
        product_alg_index: isHotsite() ? hotsiteAlgoliaIndex : algIndex || currentIndex,
        filter_action: isThreeSteps ? '3 passos' : 'Normal',
      };
    };

    return trackEvent(ProductEvents.ListFilter, getPayload());
  };

  return { trackListFilter };
};
export default useListFilter;
